import { request } from './client';

// Public — fetch a single section as the storefront sees it.
export const apiGetSiteContent = (section) => request(`/site-content/${section}`);

// Admin CRUD
export const apiAdminGetSiteContent = (section) => {
  const qs = section ? `?section=${encodeURIComponent(section)}` : '';
  return request(`/site-content/admin/all${qs}`);
};
export const apiAdminGetSiteContentSections = () => request('/site-content/admin/sections');
export const apiAdminGetPages = () => request('/site-content/admin/pages');
export const apiAdminTogglePage = (key) =>
  request(`/site-content/admin/pages/${encodeURIComponent(key)}/toggle`, { method: 'PUT' });
export const apiAdminGetHomeSections = () => request('/site-content/admin/home-sections');
export const apiAdminToggleHomeSection = (key) =>
  request(`/site-content/admin/home-sections/${encodeURIComponent(key)}/toggle`, { method: 'PUT' });
export const apiCreateSiteContent = (data) =>
  request('/site-content', { method: 'POST', body: data });
export const apiUpdateSiteContent = (id, data) =>
  request(`/site-content/${id}`, { method: 'PUT', body: data });
export const apiToggleSiteContent = (id) =>
  request(`/site-content/${id}/toggle`, { method: 'PUT' });
export const apiDeleteSiteContent = (id) =>
  request(`/site-content/${id}`, { method: 'DELETE' });
